// web/src/main.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/globals.css';

// Applied synchronously before the first render — a useEffect inside App
// would run after first paint and cause a flash of the wrong theme.
const savedTheme = localStorage.getItem('serveiq-theme') || 'light';
document.documentElement.setAttribute('data-theme', savedTheme);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
